import React from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import { Flex } from 'reflexbox'
import Tag from 'components/display/Tag'
import { TAG_COLORS } from 'components/display/Tag/constants'
import GpuSku from 'components/project/notebookGpuSku/index'
import Collapse from 'components/fulcrum/collapse/Collapse'
import MoreInfo from 'components/custom/MoreInfo'
import styles from './styles.scss'
import { compose, withState, withHandlers } from 'recompose'
import { IconButton } from 'react-toolbox/lib/button'
import Tooltip from 'react-toolbox/lib/tooltip';

const TooltipIcon = Tooltip(IconButton)

const getLifecycleTag = (lifecycle) => {
  if(lifecycle){
    return(
      <Tag color={TAG_COLORS.GREEN} text={lifecycle} className={styles.lifecycleTag}/>
    )
  }
  return
}

const getRiskTag = (risk) => {
  if(risk){
    return(
      <Tag color={TAG_COLORS.RED} text='Risk' icon='warning' className={styles.riskTag}/>
    )
  }
  return
}

const getRestrictedTag = (restricted) => {
  if(restricted){
    return(
      <Tag color={TAG_COLORS.RED} text='Restricted' icon='lock' className={styles.restrictedTag}/>
    )
  }
  return
}

const getRestrictedIcon = (restricted) => {
  if(restricted){
    return(
      <TooltipIcon tooltip='Restricted Project' tooltipPosition='right' icon='lock' styleName='restrictedIcon' theme={styles}/>
    )
  }
  return
}


const ProjectDetails = props => {
  const {
    id,
    sku,
    brand,
    gpuSku,
    partnerSiteName,
    lifecycle,
    segment,
    createdBy,
    createdAt,
    productLine,
    productClass,
    customerClass,
    architecture,
    risk,
    restricted,
    collapse,
    toggleCollapse
  } = props

  return (
    <Flex column styleName='projectDetailContainer'>

      <Flex styleName='titleRow'>
        <h5 styleName='projectNumber'>Project #{id}</h5>
        { getRestrictedIcon(restricted) }
      </Flex>

      <Flex styleName='tagRow'>
        { getLifecycleTag(lifecycle) }
        { getRiskTag(risk) }
      </Flex>
    
      <div>{partnerSiteName}</div>
      <div>{segment} - {productLine}</div>
      <div>{sku} - {brand}</div>

      <MoreInfo className={styles.moreInfoButton} action={()=>toggleCollapse()} collapsed={collapse} />

      <Collapse collapse={collapse}>
        <div>{productClass} - {customerClass}</div>
        <div>{architecture} </div>
        <div>
          <GpuSku
            segment={segment}
            gpuSku={gpuSku}
          />
        </div>
        <div styleName='projectCreationInfo'>Created by {createdBy} on {createdAt}</div>
      </Collapse>

    </Flex>
  )
}

ProjectDetails.propTypes = {
  lifecycle: PropTypes.string.isRequired,
  partnerSiteName: PropTypes.string.isRequired,
  sku: PropTypes.string.isRequired,
  brand: PropTypes.string.isRequired,
  gpuSku: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  segment: PropTypes.string.isRequired,
}

ProjectDetails.defaultProps = {
  lifecycle: '',
  gpuSku: '',
  sku: '',
  brand: '',
  partnerSiteName: '',
  id: '',
  segment: '',
}

const enhance = compose(
  withState('collapse', 'toggleCollapse', true),
  withHandlers({
    toggleCollapse: ({ toggleCollapse }) => () => toggleCollapse(t => !t)
  }),
  CSSModules(styles)
)

export default enhance(ProjectDetails)
